module.exports = __webpack_public_path__ + "img/icons8-ghost-64.d49def6c.png";